@if (hasValue) {
  <span class="metric">{{ value }}</span>
} @else {
  <span class="metric--empty">—</span>
}
